import { render, staticRenderFns } from "./OpenAnswer.vue?vue&type=template&id=58ee2a19&scoped=true&"
import script from "./OpenAnswer.vue?vue&type=script&lang=js&"
export * from "./OpenAnswer.vue?vue&type=script&lang=js&"
import style0 from "./OpenAnswer.vue?vue&type=style&index=0&id=58ee2a19&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee2a19",
  null
  
)

export default component.exports